// extracted by mini-css-extract-plugin
export default {"text":"style_text__wr3RI","loader":"style_loader__fnr3D"};